import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { exportApi, getErrorMessage } from '../../lib/api';

interface ExportMenuProps {
    disabled?: boolean;
}

const EXPORT_FORMATS = [
    { format: 'geojson' as const, label: 'GeoJSON (.geojson)' },
    { format: 'shapefile' as const, label: 'Shapefile (.zip)' },
    { format: 'kml' as const, label: 'KML (.kml)' },
    { format: 'gpkg' as const, label: 'GeoPackage (.gpkg)' },
];

export default function ExportMenu({ disabled = false }: ExportMenuProps) {
    const [showMenu, setShowMenu] = useState(false);
    const [exporting, setExporting] = useState(false);

    const handleExport = async (format: 'geojson' | 'shapefile' | 'kml' | 'gpkg') => {
        setExporting(true);
        setShowMenu(false);
        try {
            await exportApi.downloadPolygons(format);
            toast.success(`Exportación ${format.toUpperCase()} descargada`);
        } catch (error: any) {
            toast.error(getErrorMessage(error) || 'Error al exportar');
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="relative">
            <button
                onClick={() => setShowMenu(!showMenu)}
                disabled={exporting || disabled}
                className="btn-secondary flex items-center gap-2 text-sm"
            >
                {exporting ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                    <Download className="w-4 h-4" />
                )}
                Exportar
            </button>
            {showMenu && (
                <div className="absolute right-0 top-full mt-1 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-1 z-50 min-w-[180px] max-w-[calc(100vw-1.5rem)]">
                    {EXPORT_FORMATS.map(({ format, label }) => (
                        <button
                            key={format}
                            onClick={() => handleExport(format)}
                            className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                            {label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
